import "./style.css";
import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { AnimatePresence } from "framer-motion";
import { Link } from "react-router-dom";
import { getPendingFriendRequests } from "../../redux/friend/friendAction";
import { FaUserFriends } from "react-icons/fa";
import { toast } from "react-toastify";
import UserCard from "../FindfriendPage/UserCard";
import { ACTIONS_BY_STATUS, STATUS_NOTE } from "../FindfriendPage/friendRequestActions";

const loadingArray = new Array(3).fill(null);

const FriendRequestItem = ({ item, userId }) => {
  const dispatch = useDispatch();
  const [pendingAction, setPendingAction] = useState(null);

  const status = item.requestStatus || "pending";
  const actions = ACTIONS_BY_STATUS[status] || [];

  const runAction = async ({ action, thunk }) => {
    if (pendingAction) return;
    setPendingAction(action);
    try {
      await dispatch(thunk({ userId, friendId: item.userId })).unwrap();
    } catch (error) {
      toast.error(error.message || "That didn't go through - please try again.");
    } finally {
      setPendingAction(null);
    }
  };

  return (
    <UserCard
      user={item}
      meta={
        <p className="text-xs text-customGold">
          {STATUS_NOTE[status] || "Sent you a friend request"}
        </p>
      }
      renderActions={() => (
        <div className="flex gap-2 w-full">
          {actions.map(({ action, label, icon: Icon, className, loadingLabel, ...rest }) => (
            <button
              key={action}
              disabled={!!pendingAction}
              className={`flex-1 rounded text-sm py-2 disabled:opacity-50 disabled:cursor-not-allowed transition-colors flex items-center justify-center gap-2 ${className}`}
              onClick={() => runAction({ action, ...rest })}
            >
              {pendingAction === action ? (
                <div className="w-4 h-4 border-2 border-current border-t-transparent rounded-full animate-spin" />
              ) : (
                <Icon className="w-4 h-4" />
              )}
              {pendingAction === action ? loadingLabel : label}
            </button>
          ))}
        </div>
      )}
    />
  );
};

function FriendRequest() {
  const dispatch = useDispatch();
  const { userData } = useSelector((state) => state.user);
  const { friendRequests, requestLoading } = useSelector((state) => state.friend);
  const userId = userData?.userId;

  useEffect(() => {
    if (userId) dispatch(getPendingFriendRequests(userId));
    return () => {
      if (userId) dispatch(getPendingFriendRequests(userId));
    };
  }, [dispatch, userId]);

  const showSkeleton = requestLoading && friendRequests?.length === 0;

  return (
    <div className="friend-con bg-customDark shadow-black absolute text-white p-3 mt-3 right-0 rounded-lg w-full sm:w-[380px] shadow-md animate-fade-in z-40">
      <h2 className="text-sm font-semibold px-2 pb-2 border-b border-gray-700">Friend Requests</h2>

      {showSkeleton ? (
        <div className="max-h-[450px] overflow-y-auto scrollbar-hide space-y-3 pr-1 pt-3">
          {loadingArray.map((_, index) => (
            <UserCard key={index} user={null} linkToProfile={false} />
          ))}
        </div>
      ) : friendRequests?.length > 0 ? (
        <div className="max-h-[450px] overflow-y-auto scrollbar-hide space-y-3 pr-1 pt-3">
          <AnimatePresence>
            {friendRequests.map((item) => (
              <FriendRequestItem key={item.userId} item={item} userId={userId} />
            ))}
          </AnimatePresence>
        </div>
      ) : (
        <div className="flex flex-col items-center justify-center text-center gap-2 py-8">
          <FaUserFriends className="w-12 h-12 text-gray-500" />
          <p className="text-sm text-gray-400">No friend requests at the moment</p>
          <Link
            to="/friends?type=suggested-account"
            className="mt-1 text-xs text-customGold hover:underline"
          >
            Find friends to connect with
          </Link>
        </div>
      )}
    </div>
  );
}

export default FriendRequest;
